const RECHARGE_API_URL = (environment, environmentUri = "") => {
  switch (environment) {
    case "prod":
      return "https://api.rechargeapps.com";
    case "stage":
      return "https://api.stage.rechargeapps.com";
    case "preprod":
    case "prestage":
      return `${environmentUri}/api`;
  }
};
const RECHARGE_ADMIN_URL = (environment, environmentUri = "") => {
  switch (environment) {
    case "prod":
      return "https://admin.rechargeapps.com";
    case "stage":
      return "https://admin.stage.rechargeapps.com";
    case "preprod":
    case "prestage":
      return environmentUri;
  }
};
const RECHARGE_CDN_URL = (environment) => {
  switch (environment) {
    case "prod":
    case "preprod":
      return "https://static.rechargecdn.com";
    case "stage":
    case "prestage":
      return "https://static.stage.rechargecdn.com";
  }
};
const SHOPIFY_APP_PROXY_URL = "/tools/recurring";

export { RECHARGE_ADMIN_URL, RECHARGE_API_URL, RECHARGE_CDN_URL, SHOPIFY_APP_PROXY_URL };
//# sourceMappingURL=api.js.map
